import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { MetadataCommonFields } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataCommonFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import {
  BedrockFlowAgentAliasNodes,
  BedrockFlowExecutionRoleARN,
  BedrockFlowKMSKeyARN,
  BedrockFlowKnowledgeBaseNodes,
  BedrockFlowLambdaFunctionNodes,
  BedrockFlowPromptNodeGuardrails,
  BedrockFlowPromptNodes,
  BedrockFlowRetrievalNodeS3Buckets,
  BedrockFlowStorageNodeS3Buckets,
} from '../../../../Components/MetadataField/MetaGridFields';

export const AWSBedrockFlowMetadata: FC = () => {
  const { resourceDetails, resourceInsight } = useActiveResourceContext();
  const { data: resource } = resourceDetails;
  const { data: insight } = resourceInsight;
  const metadata = { ...resource, ...insight };

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      <MetadataCommonFields
        state={metadata}
        availabilityZone="None"
        vpc="None"
        owner="None"
        createdAt={metadata}
        updatedAt={metadata}
      />
      {BedrockFlowAgentAliasNodes(metadata)}
      {BedrockFlowKnowledgeBaseNodes(metadata)}
      {BedrockFlowLambdaFunctionNodes(metadata)}
      {BedrockFlowPromptNodes(metadata)}
      {BedrockFlowPromptNodeGuardrails(metadata)}
      {BedrockFlowStorageNodeS3Buckets(metadata)}
      {BedrockFlowRetrievalNodeS3Buckets(metadata)}
      {BedrockFlowExecutionRoleARN(metadata)}
      {BedrockFlowKMSKeyARN(metadata)}
    </Grid>
  );
};
